import * as React from 'react';
import { returnChild } from './category';
import { Group } from './categoriesGroup';
import { CategoryContext } from '../contexts';
import useHome from '../hooks/useHome';
export { Group };
/**
 * This loops over all the top level categories and repeats the children.
 * @param props For children you can pass JSX or a render prop.
 */
export const Loop = ({ children }) => {
    const home = useHome();
    if (!home || !home.categories) {
        return null;
    }
    const categories = home.categories || [];
    return (React.createElement(React.Fragment, null, categories.map((category, index) => (React.createElement(CategoryContext.Provider, { key: category.id, value: category }, returnChild(children, {
        category,
        index,
    }))))));
};
Loop.displayName = 'Categories.Loop';
//# sourceMappingURL=categories.js.map